import { Link } from 'aresui';

import * as Icons from 'icons';
import Button from 'components/Button';

import { FooterContainer } from './styles';

function Footer() {
	return (
		<FooterContainer>
			<div className="content">
				<div className="main">
					<h1>Vamos iniciar um projeto juntos?</h1>
					<p>Transformando ideias em projetos excepcionais</p>

					<Button variant="outlined" linkTo="/contact">
						Iniciar projeto
						<Icons.FiArrowRight />
					</Button>
				</div>

				<div className="column">
					<strong>Site</strong>

					<ul>
						<li>
							<Link to="/">Projetos</Link>
						</li>

						<li>
							<Link to="/contact">Contato</Link>
						</li>

						<li>
							<Link to="/">Projetos</Link>
						</li>
					</ul>
				</div>

				<div className="column">
					<strong>Contato</strong>

					<ul>
						<li className="contact">
							<small>E-mail</small>
							<Link to="mailto:contato@jeffersoncalmon.dev">
								contato@jeffersoncalmon.dev
							</Link>
						</li>

						<li className="contact">
							<small>Whatsapp e telefone</small>
							<Link to="tel:5573988597392">(73) 98859-7392</Link>
						</li>
					</ul>
				</div>
			</div>

			<div className="content copyright">
				<div className="content">
					<a href="#header">
						Voltar ao topo <Icons.FiCornerRightUp />
					</a>

					<p>
						&copy; {new Date().getFullYear()} Jefferson Calmon.
						Todos os direitos reservados
					</p>
				</div>
			</div>
		</FooterContainer>
	);
}

export default Footer;
